<template>
  <fragment>
    <common-header
      subname="프로그램 관리"
      name="프로그램 신청 관리"
      v-bind:searchbox="true"
      v-bind:menus="menus"
      v-bind:buttons="buttons"
      @keywordChanged="keywordChanged"
    ></common-header>

    <section ref="container" class="container">
      <ctrl-category-filter
        @changeFilters="changeFilters"
        @changeCategories="changeCategories"
        listName="수강 신청 목록"
      ></ctrl-category-filter>

      <div class="container-fiuld clearfix">
        <div class="btn-group-box clearfix">
          <div class="btn-group pull-left clearfix">
            <div class="input-group w140 pull-left round m-r-5" style="margin-top: 1px;">
              <span class="input-group-addon v-mid">
                <select
                  v-model="selectedLecture"
                  class="form-control round-left"
                  @change="setPageSizeOrder"
                >
                  <option :value="null">== 프로그램 선택 ==</option>
                  <option
                    v-for="(lec,idx) in lectures"
                    :item="lec"
                    :index="idx"
                    :key="'lecture-list-'+idx+'-'+hash(lec)"
                    :value="lec"
                  >{{lec.lecName}}</option>
                </select>
              </span>
            </div>
            <div class="input-group w140 pull-left round m-r-5" style="margin-top: 1px;">
              <span class="input-group-addon v-mid">
                <select v-model="all_applStatus" class="form-control round-left">
                  <option value="신청">신청</option>
                  <option value="승인">승인</option>
                  <option value="취소">취소</option>
                  <option value="반려">반려</option>
                </select>
              </span>
              <span class="input-group-addon v-mid" style="width:50px;">
                <button
                  @click="allChangeStatue"
                  class="btn bg-deepblue full-width text-white p-r-5 p-l-5 round-right"
                  style="margin-top: -1px;"
                >일괄변경</button>
              </span>
            </div>
            <!-- <div class="select pull-left m-r-5">
              <a @click="mail" class="btn round">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  class="v-mid m-r-5"
                  width="22"
                  height="20"
                  viewBox="0 0 22 20"
                >
                  <path
                    class="msg-i"
                    d="M262.519,1266.28a0.158,0.158,0,0,0,.019.08c0,0.02.019,0.06,0.019,0.08a0.473,0.473,0,0,1,.019.08,0.3,0.3,0,0,1,.038.08c0.019,0.02.019,0.04,0.038,0.06a0.107,0.107,0,0,1,.038.06l0.057,0.06,0.019,0.02a0.019,0.019,0,0,1,.019.02,0.447,0.447,0,0,0,.209.12,0.037,0.037,0,0,1,.038.02,0.91,0.91,0,0,0,.228.04h20.5a0.91,0.91,0,0,0,.228-0.04,0.037,0.037,0,0,0,.038-0.02,2.043,2.043,0,0,0,.209-0.12,0.019,0.019,0,0,0,.019-0.02l0.019-.02,0.057-.06a0.107,0.107,0,0,0,.038-0.06c0.019-.02.019-0.04,0.038-0.06a0.3,0.3,0,0,0,.038-0.08,0.1,0.1,0,0,0,.019-0.08c0-.02.019-0.06,0.019-0.08a0.473,0.473,0,0,0,.019-0.08v-18.46a0.792,0.792,0,0,0-.779-0.82H263.279a0.792,0.792,0,0,0-.779.82v18.38A0.1,0.1,0,0,1,262.519,1266.28Zm2.432-.94,5.756-7.25,2.394,1.76a0.752,0.752,0,0,0,.874,0l2.394-1.76,5.756,7.25H264.951Zm18.067-1.44-5.377-6.75,5.358-3.94v10.69h0.019Zm-18.96-15.26H283v2.58l-9.461,6.95-9.48-6.95v-2.58Zm0,4.57,5.357,3.94-5.357,6.75v-10.69Z"
                    transform="translate(-262.5 -1247)"
                  />
                </svg> 전자우편 보내기
              </a>
            </div> -->
            <div class="select pull-left m-r-5">
              <a @click="sms" class="btn round">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  class="v-mid m-r-5"
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                >
                  <path
                    class="sms-i"
                    d="M386.428,1249.93a10,10,0,0,1,14.807,13.41,3.719,3.719,0,0,0,1.575,1.82,0.933,0.933,0,0,1-.268,1.76,5.3,5.3,0,0,1-.708.05h0a6.478,6.478,0,0,1-3.6-1.16A10,10,0,0,1,386.428,1249.93Zm0.8,13.34a8.909,8.909,0,0,0,10.763,1.38,0.59,0.59,0,0,1,.285-0.08,0.621,0.621,0,0,1,.348.11,5.414,5.414,0,0,0,3.138,1.16,5.789,5.789,0,0,1-1.714-2.37,0.561,0.561,0,0,1,.1-0.6A8.871,8.871,0,1,0,387.229,1263.27Zm2.082-9.57h8.38a0.565,0.565,0,1,1,0,1.13h-8.38A0.565,0.565,0,1,1,389.311,1253.7Zm0,2.73h8.38a0.569,0.569,0,0,1,.565.57,0.561,0.561,0,0,1-.565.56h-8.38a0.562,0.562,0,0,1-.566-0.56A0.573,0.573,0,0,1,389.311,1256.43Zm0,2.74h8.38a0.565,0.565,0,1,1,0,1.13h-8.38A0.565,0.565,0,1,1,389.311,1259.17Z"
                    transform="translate(-383.5 -1247)"
                  />
                </svg> 문자 보내기
              </a>
            </div>
            <!-- <div class="select pull-left m-r-5">
              <a @click="note" class="btn round">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  class="v-mid m-r-5"
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                >
                  <path
                    class="sms-i"
                    d="M386.428,1249.93a10,10,0,0,1,14.807,13.41,3.719,3.719,0,0,0,1.575,1.82,0.933,0.933,0,0,1-.268,1.76,5.3,5.3,0,0,1-.708.05h0a6.478,6.478,0,0,1-3.6-1.16A10,10,0,0,1,386.428,1249.93Zm0.8,13.34a8.909,8.909,0,0,0,10.763,1.38,0.59,0.59,0,0,1,.285-0.08,0.621,0.621,0,0,1,.348.11,5.414,5.414,0,0,0,3.138,1.16,5.789,5.789,0,0,1-1.714-2.37,0.561,0.561,0,0,1,.1-0.6A8.871,8.871,0,1,0,387.229,1263.27Zm2.082-9.57h8.38a0.565,0.565,0,1,1,0,1.13h-8.38A0.565,0.565,0,1,1,389.311,1253.7Zm0,2.73h8.38a0.569,0.569,0,0,1,.565.57,0.561,0.561,0,0,1-.565.56h-8.38a0.562,0.562,0,0,1-.566-0.56A0.573,0.573,0,0,1,389.311,1256.43Zm0,2.74h8.38a0.565,0.565,0,1,1,0,1.13h-8.38A0.565,0.565,0,1,1,389.311,1259.17Z"
                    transform="translate(-383.5 -1247)"
                  />
                </svg> 쪽지 보내기
              </a>
            </div> -->
          </div>

          <div class="btn-group pull-right clearfix">
            <select
              class="form-control round pull-left m-r-5"
              v-model="pageSize"
              @change="setPageSize()"
            >
              <option value="10">10개씩 보기</option>
              <option value="30">30개씩 보기</option>
              <option value="50">50개씩 보기</option>
            </select>
            <select
              v-model="orderBy"
              @change="setPageSizeOrder()"
              class="form-control round pull-left m-r-5"
            >
              <option value="CODE_91_APPL.REG_DATE ASC">신청일 ↑</option>
              <option value="CODE_91_APPL.REG_DATE DESC">신청일 ↓</option>
              <option value="LEC_NAME ASC">프로그램명순</option>
              <option value="EDU_START_DATE ASC">교육시작일순</option>
            </select>
            <div class="select pull-left m-r-5">
              <a class="btn round pull-left" @click="download">
                <img class="v-mid m-r-5" src="images/x.png" alt /> 전체 다운로드
              </a>
            </div>
          </div>
        </div>

        <table class="table2 table-hover m-t-10 text-center">
          <thead>
            <tr class="bg-lightgray">
              <th class="w100">
                <input
                  id="table-allcheck"
                  @click="checkAll"
                  ref="checkAll"
                  class="checkbox"
                  type="checkbox"
                />
                <label for="table-allcheck">체크버튼</label>
              </th>
              <th class="w120">신청일</th>
              <th class="w100">신청자</th>
              <th class="w180">프로그램</th>
              <th class="w300">수강기간</th>
              <!-- <th class="w140">강사배정</th> -->
              <th class="w120">신청관리</th>
              <th class="w40"></th>
            </tr>
          </thead>
          <tbody
            @click="removeSubMenu"
            v-for="(datum,index) in appl_list"
            :key="hash({a:datum.applId,b:datum.checked_})"
          >
            <tr class="margin">
              <td colspan="9"></td>
            </tr>
            <tr :class="selectedMember==datum.mber?'on':''" @click="selectMemberData(datum.mber)">
              <td>
                <input
                  type="checkbox"
                  :id="'applItem-'+datum.applId"
                  :value="datum.applId"
                  v-model="datum.checked_"
                  class="checkbox"
                  @change="checkOne"
                />
                <label :for="'applItem-'+datum.applId">체크버튼</label>
              </td>
              <td>
                {{datum.regDate | parseRegDate}}<br>
                {{datum.regDate | parseRegTime}}
              </td>
              <td>{{datum.mberName}}<br>{{datum.mberId}}</td>
              <td class="text-left">
                {{datum.lec.category}}
                <br />
                <span
                  style="font-weight:bold;color:#ff0000;"
                  v-if="datum.lec.deleted==1"
                >(존재하지 않는 프로그램)</span>
                {{datum.lec.lecName}}
              </td>
              <td>
                {{datum | parseEduDate}}
                <span style="opacity:0">({{datum.lec.eduPeriodType}})</span>
              </td>
              <!-- <td>{{datum.applEduList.length?datum.applEduList[0].mberName:(datum.lec.eduList.length?datum.lec.eduList[0].mberName:"")}}</td> -->
              <!-- <td>
                {{Array.isArray(datum.applEduList) && datum.applEduList.length ? datum.applEduList.map(edu=> edu.mberName).join(', ') : datum.lec.instAllotType}}<br>
                <button
                  v-show="datum.lec.instAllotType == '신청 후 배정'"
                  class="btn-sm round"
                  @click="openSetTeacherModal(datum)"
                >강사배정</button>
              </td> -->
              <td>
                <select
                  class="form-control-sm full-width m-b-0 round"
                  v-model="datum.applStatus"
                  @change="changeStatus(datum)"
                >
                  <option value="신청">신청</option>
                  <option value="승인">승인</option>
                  <option value="취소">취소</option>
                  <option value="반려">반려</option>
                </select>
              </td>
              <td>
                <div class="see-more">
                  <a @click="openSubMenu(index)($event)">
                    <img src="images/see-more.png" width="5" alt />
                  </a>
                  <ul :class="{on:subMenuIndex === index}">
                    <li @click="openApplyDetailModal(datum)">신청상세</li>
                    <!-- <li v-if="datum.lec.deleted==0" @click="openClassroom(datum.lecId)">강의실</li> -->
                    <li @click="deleteAppl(datum.applId)">삭제</li>
                  </ul>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
        <div v-if="!appl_list.length" class="text-center">
          신청건이 없습니다.
        </div>
        <ctrl-pagination
          :currentPage="offset / pageSize + 1"
          :pageSize="parseInt(pageSize)"
          :totalCount="totalCount"
          :key="hash({pageSize, offset, totalCount})"
          @pageChanged="onPageChanged"
        ></ctrl-pagination>
      </div>
      <ctrl-member-summary
        v-if="selectedMember"
        ref="scrollableSummary"
        :member="selectedMember"
        @onSms="onSms(selectedMember)"
        @onEmail="onEmail(selectedMember)"
      ></ctrl-member-summary>
    </section>

    <modal-apply-detail
      :config="modals.ModalApplyDetail"
      :key="hash(modals.ModalApplyDetail)"
      @close="modals.ModalApplyDetail.show=false"
    ></modal-apply-detail>

    <modal-appl-manual-excel :config="modals.ModalApplManualExcel" @close="modals.ModalApplManualExcel.show=false;" :key="hash(modals.ModalApplManualExcel)" @refresh="refresh" @onDone="onDone" @onConfirm="onConfirm"></modal-appl-manual-excel>

    <ModalAssignTeacher
      @close="modals.ModalAssignTeacher.show=false;"
      @assign="assign"
      @sendEmail="sendEmail"
      :config="modals.ModalAssignTeacher"
      :key="hash(modals.ModalAssignTeacher)"
    ></ModalAssignTeacher>

    <modal-email
      :config="modals.ModalEmail"
      @close="modals.ModalEmail.show=false;"
      :key="hash(modals.ModalEmail)"
    ></modal-email>
    <modal-note
      :config="modals.ModalNote"
      @close="modals.ModalNote.show=false;"
      :key="hash(modals.ModalNote)"
      @onDone="onDone"
      @onConfirm="onConfirm"
    ></modal-note>
    <modal-sms
      :config="modals.ModalSms"
      @close="modals.ModalSms.show=false;"
      :key="hash(modals.ModalSms)"
    ></modal-sms>

    <modal-confirm
      :config="modals.ModalConfirm"
      @no="removeCancleItem()"
      :key="hash(modals.ModalConfirm)"
    ></modal-confirm>
    <modal-alert
      :config="modals.ModalAlert"
      @close="modals.ModalAlert.show=false;"
      :key="hash(modals.ModalAlert)"
    ></modal-alert>
    <common-footer></common-footer>
  </fragment>
</template>



<script>
import fnAdjustHeight from "../mixins/fnAdjustHeight.js";
import fnUserList from "../mixins/fnUserList";
import fnScrollable from "../mixins/fnScrollable";
import CommonHeader from "../components/CommonHeader.vue";
import CommonFooter from "../components/CommonFooter.vue";
import CtrlCategoryFilter from "../components/CtrlCategoryFilter.vue";
import CtrlMemberSummary from "../components/CtrlMemberSummary.vue";
import CtrlPagination from "../components/CtrlPagination.vue";

import ModalAssignTeacher from "../modals/ModalAssignTeacher";
import ModalConfirm from "../modals/ModalConfirm.vue";
import ModalAlert from "../modals/ModalAlert.vue";
import ModalApplyDetail from "../modals/ModalApplyDetail.vue";
import ModalApplManualExcel from "../modals/ModalApplManualExcel.vue";
import ModalEmail from "../modals/ModalEmail.vue";
import ModalNote from "../modals/ModalNote.vue";
import ModalSms from "../modals/ModalSms.vue";

import axios from "axios";
import server from "../statics/server";
import moment from "moment";
import _ from "lodash";

export default {
  name: "ViewClassApplyList",
  mixins: [fnAdjustHeight, fnUserList, fnScrollable],
  components: {
    CommonHeader,
    CommonFooter,
    CtrlCategoryFilter,
    CtrlMemberSummary,
    CtrlPagination,

    ModalAssignTeacher,
    ModalConfirm,
    ModalAlert,
    ModalApplyDetail,
    ModalApplManualExcel,
    ModalEmail,
    ModalNote,
    ModalSms
  },

  mounted: function() {
    //this.getLecList();
    this.setPageSizeOrder();
  },
  filters: {
    parseRegDate(date) {
      return moment(date).format("YYYY-MM-DD");
    },
    parseRegTime(date) {
      return moment(date).format("HH시 mm분");
    },
    parseContent(val) {
      return val.length > 30 ? val.slice(0, 30) + "..." : val;
    },
    parseEduDate(appl) {
      if(!appl.applEduDateList || !Array.isArray(appl.applEduDateList)) {
        return "승인되지 않았으므로 수강기간을 산정할 수 없음";
      } else if (appl.applEduDateList.length == 1) {
        return (
          moment(appl.applEduDateList[0].eduStartDate).format("YYYY년 M월 D일") +
          " ~ " +
          moment(appl.applEduDateList[0].eduEndDate).format("YYYY년 M월 D일")
        );
      } else if (appl.applEduDateList.length > 1) {
        return (
          moment(appl.applEduDateList[0].eduStartDate).format("YYYY년 M월 D일") +
          " ~ " +
          moment(appl.applEduDateList[appl.applEduDateList.length-1].eduEndDate).format("YYYY년 M월 D일") +
          " (총 "+appl.applEduDateList.length+"회)"
        );
      } else {
        return "승인되지 않았으므로 수강기간을 산정할 수 없음";
      }
    },
    parseApplInfo(applId) {
      return applId; //_.filter(this.appl_info_list, {applId});
    }
  },
  data: function() {
    return {
      menus: [
        { name: "프로그램 신청 관리", link: "/classes/apply", selected: true },
        // { name: "수강현황 관리", link: "/classes/progress", selected: false },
        { name: "프로그램 목록 관리", link: "/classes", selected: false }
      ],
      buttons: [
        {name:'일괄 등록',fn:this.onApplRegisterExcel}
      ],
      data: [{}],
      subMenuIndex: -1,

      init_list: [
        { db_name: "APPL", list_name: "appl_list" },
        { db_name: "APPL_INFO", list_name: "appl_info_list" },
        { db_name: "APPL_EDU_DATE", list_name: "appl_edu_date_list" },
        { db_name: "APPL_EDU", list_name: "appl_edu" }
      ],
      appl_list: [],
      appl_info_list: [],
      appl_edu_date_list: [],
      appl_edu: [],

      all_applStatus: "신청",
      checked_all: false,
      checked_item: [],
      selectedMember: null,

      modals: {
        ModalAssignTeacher: ModalAssignTeacher.default(),
        ModalAlert: ModalAlert.default(),
        ModalConfirm: ModalConfirm.default(),
        ModalApplyDetail: ModalApplyDetail.default(),
        ModalApplManualExcel: ModalApplManualExcel.default(),
        ModalEmail: ModalEmail.default(),
        ModalNote: ModalNote.default(),
        ModalSms: ModalSms.default()
      },

      // 정렬
      totalCount: 0,
      offset: 0,
      keyword: "",
      pageSize: 10,
      orderBy: "CODE_91_APPL.REG_DATE DESC",
      filterList: [],
      categoryList: [],
      lectures: [],
      selectedLecture: null
    };
  },
  methods: {
    keywordChanged(keyword) {
      this.keyword = keyword;
      this.setPageSizeOrder();
    },
    onPageChanged(page) {
      this.offset = (page - 1) * this.pageSize;
      this.setPageSizeOrder();
    },
    changeFilters(filter_list) {
      this.filterList = filter_list;
      this.setPageSizeOrder();
    },
    changeCategories(category_list) {
      this.categoryList = category_list;
      this.getLecList();
      this.setPageSizeOrder();
    },
    setPageSize() {
      this.offset = "0";
      this.setPageSizeOrder();
    },
    setPageSizeOrder() {
      let config_option = {
        keyword: this.keyword,
        offset: this.offset.toString(),
        pageSize: this.pageSize,
        orderBy: this.orderBy,
        filterList: this.filterList,
        categoryList: this.categoryList
      };
      if (this.selectedLecture)
        config_option.lecId = this.selectedLecture.lecId;
      config_option = _.pickBy(config_option);
      this.getList(
        this.init_list[0].db_name,
        this.init_list[0].list_name,
        config_option
      );
    },
    refreshData() {
      this.getList(this.init_list[0].db_name, this.init_list[0].list_name, {});
    },
    getLecList: function() {
      axios
        .post(server.addr() + server.api.LECTURE, {
          categoryList: [...this.categoryList]
        })
        .then(response => {
          this.lectures = response.data.list;
        });
    },
    getList(db_name, list_name, config_option) {
      // select_name : 선택 분류, parentsId_val : 검색할 카테고리 아이디 list_name : 갱신 할 리스트 명
      const self = this;
      let config = config_option || {};
      server.postAxios(db_name, config, ({ data, err }) => {
        err;
        if (list_name == "appl_list") {
          self.totalCount = parseInt(data.filtered);
          data.list = data.list.map(e => {
            e.checked_ = false;
            return e;
          });
        }
        self[list_name] = data.list;
      });
    },
    removeModal: function(smsTemplId) {
      this.remove_sms_item = smsTemplId;
      this.modals.ModalConfirm.msg = "프로그램 신청건을 정말 삭제하시겠습니까?";
      this.modals.ModalConfirm.btnYes.name = "취소";
      this.modals.ModalConfirm.btnNo.name = "삭제";
      this.modals.ModalConfirm.show = true;
    },
    removeCancleItem() {
      this.modals.ModalConfirm.show = false;
      this.remove_survey_item = "";
    },
    allChangeStatue() {
      // 신청, 승인, 반려 일괄 변경
      const self = this;
      let modify_list = [];
      self.appl_list
        .filter(appl => appl.checked_)
        .forEach(appl => {
          modify_list.push({
            applId: appl.applId,
            applStatus: self.all_applStatus
          });
        });
      // eslint-disable-next-line
      // console.log("allChangeStatue : ", modify_list);
      // axios
      // .patch(server.addr() + server.api.APPL, {
      //   ...modify_list
      // })
      // .then(() => {
      //   this.modals.ModalAlert.msg = "일괄 변경 되었습니다.";
      //   this.modals.ModalAlert.show = true;
      //   this.setPageSizeOrder();
      // });

      server.patchListAxios("APPL", modify_list, () => {
        this.modals.ModalAlert.msg = "일괄 변경 되었습니다.";
        this.modals.ModalAlert.show = true;
        this.setPageSizeOrder();
      });
    },
    checkOne: function() {
      if (this.appl_list.find(e => e.checked_ == false)) {
        this.$refs.checkAll.checked = false;
      } else {
        this.$refs.checkAll.checked = true;
      }
    },
    checkAll: function() {
      if (this.$refs.checkAll.checked) {
        this.appl_list.forEach(e => (e.checked_ = true));
      } else {
        this.appl_list.forEach(e => (e.checked_ = false));
      }
    },
    // 수강기간
    eduDate(item) {
      // applId 로 appl_edu_date filter
      let date_list = _.filter(this.appl_edu_date_list, {
        applId: item.applId
      });
      let add_text =
        date_list.length > 1 ? "외" + date_list.length - 1 + "일" : "";
      if (date_list.length != 0) {
        return (
          moment(date_list[0].eduStartDate).format("YYYY년 M월 D일") + add_text
        );
      }
      return "알수 없음";
    },
    mail: function() {
      let targets = this.appl_list.filter(a => a.checked_);
      if (targets.length == 0) {
        this.modals.ModalAlert.msg = "전자우편을 수신할 대상을 선택하세요.";
        this.modals.ModalAlert.show = true;
        return;
      }
      targets = targets.map(t => t.mber).filter(t => t);
      this.onMailForm(false, targets);
    },
    sendEmail: function(mber) {
      if (mber) this.onMailForm(false, [mber]);
    },
    sms: function() {
      let targets = this.appl_list.filter(a => a.checked_);
      if (targets.length == 0) {
        this.modals.ModalAlert.msg = "문자를 수신할 대상을 선택하세요.";
        this.modals.ModalAlert.show = true;
        return;
      }
      targets = targets.map(t => t.mber).filter(t => t);
      this.onSMSForm(false, targets);
    },
    note: function() {
      let targets = this.appl_list.filter(a => a.checked_);
      if (targets.length == 0) {
        this.modals.ModalAlert.msg = "쪽지를 수신할 대상을 선택하세요.";
        this.modals.ModalAlert.show = true;
        return;
      }
      targets = targets.map(t => t.mber).filter(t => t);
      this.onNoteForm(false, targets);
    },
    // 수강 신청목록 조회
    refresh: function() {
      axios
        .post(server.addr() + server.api.APPL, {
          offset: this.offset,
          pageSize: this.pageSize,
          orderBy: this.orderBy
        })
        .then(response => {
          this.data = response.data.list.map(e => {
            e.regDate = moment(e.regDate).format("YYYY-MM-DD HH:mm");
            return e;
          });
        });
    },
    // 수강 신청 상태변경
    changeStatus: function(appl) {
      axios
        .patch(server.addr() + "/appl/" + appl.applId, {
          applStatus: appl.applStatus
        })
        .then(() => {
          this.setPageSizeOrder();
        });
    },
    // 강의실 진입
    openClassroom: function(lecId) {
      window.open("#/classroom/" + lecId + "/curriculum");
    },

    openSetTeacherModal: function(item) {
      this.modals.ModalAssignTeacher.appl_list = this.appl_list.filter(appl => appl.applId === item.applId)[0];
      this.modals.ModalAssignTeacher.applId = item.applId;
      this.modals.ModalAssignTeacher.show = true;
    },
    assign: function(teachers) {
      axios
        .patch(
          server.addr() + server.api.APPL_EDU,
          teachers.map(t => {
            return {
              applId: this.modals.ModalAssignTeacher.applId,
              mberId: t.mberId,
              mberName: t.mberName
            };
          })
        )
        .then(response => {
          response;
          this.setPageSizeOrder();
          this.modals.ModalAssignTeacher.show = false;
        });
    },
    openApplyDetailModal: function(appl) {
      this.modals.ModalApplyDetail.appl_info = appl;
      this.modals.ModalApplyDetail.show = true;
    },
    removeSubMenu: function(event) {
      event;
      this.subMenuIndex = -1;
    },
    openSubMenu: function(index) {
      return event => {
        event.stopPropagation();
        if (index === this.subMenuIndex) {
          this.subMenuIndex = -1;
        } else this.subMenuIndex = index;
      };
    },
    deleteAppl: function(applId) {
      this.modals.ModalConfirm.msg = "프로그램 신청건을 정말 삭제하시겠습니까?";
      this.modals.ModalConfirm.btnYes.name = "삭제";
      this.modals.ModalConfirm.btnYes.fn = () => {
        this.modals.ModalConfirm.show = false;
        axios.delete(server.addr() + server.api.APPL + "/" + applId)
          .then(() => {
            this.setPageSizeOrder();
            this.modals.ModalAlert.msg = "프로그램 신청건을 삭제하였습니다.";
            this.modals.ModalAlert.show = true;
          });
      };
      this.modals.ModalConfirm.show = true;
    },
    onApplRegisterExcel: function() {
			this.modals.ModalApplManualExcel.show = true;
		},
    download: function() {
      const { keyword, orderBy, filterList, categoryList } = this;
      if (this.selectedLecture) {
        axios.post(server.addr() + server.api.APPL_EXCEL, {
            keyword,
            orderBy,
            filterList,
            categoryList,
            lecId: this.selectedLecture.lecId
          })
          .then(response => {
            window.open(`${server.addr()}/download/${response.data}`, "", "");
          });
      } else {
        axios.post(`${server.addr()}${server.api.APPL_EXCEL}`, {
            keyword,
            orderBy,
            filterList,
            categoryList
          })
          .then(response => {
            window.open(`${server.addr()}/download/${response.data}`, "", "");
          });
      }
    }
  }
};
</script>

<style scoped>
.see-more > ul.on {
  display: block;
}
</style>
